import {ReduceStore} from 'flux/utils';
import Dispatcher from '../../dispatcher';
import ACTION_TYPES from '../../constants/action_types';
import ProductBatchStocksConstants from '../../constants/product_batch_stocks_constants';
import ProductBatchStocksModel from '../models/product_batch_stocks';

class ProductBatchStocksStoreClass extends ReduceStore {
    getInitialState() {
        return {
            productBatchStocks: [],
        };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.PRODUCT_BATCH_STOCKS_ACTION) {
            switch (action.type) {
                case ProductBatchStocksConstants.SET_PRODUCT_BATCH_STOCKS:
                    state.productBatchStocks = action.payload.map((product) => {
                        return new ProductBatchStocksModel(product);
                    });

                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const ProductBatchStocksStore = new ProductBatchStocksStoreClass(Dispatcher);
export default ProductBatchStocksStore;
